/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_CityInputs */

const cs_filter_city = /** @type {(inputs: Filter_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Město`)
};

const en_filter_city = /** @type {(inputs: Filter_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Filter_CityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_city = /** @type {((inputs?: Filter_CityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_CityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_city(inputs)
	return cs_filter_city(inputs)
});